import Badge from '../Badge';

import './styles.scss';

interface IListExtenderProps {
  currentNum: number;
  totalNum: number;
  gap: number;
  onExtend(): void;
  size?: number;
  ph?: number;
}

const ListExtender = ({
  currentNum,
  totalNum,
  gap,
  onExtend,
  size,
  ph,
}: IListExtenderProps) => {
  return (
    <div
      className='list_extender'
      style={{ paddingLeft: ph, paddingRight: ph }}
      onClick={onExtend}
    >
      <div
        className='list_extender__dots icon-dots'
        style={{ marginRight: gap }}
      />
      <div className='list_extender__extend icon-stretch-list' />
      <Badge
        variant='fill'
        klass='grey'
        text={`${currentNum} to ${totalNum}`}
        size={size}
      />
    </div>
  );
};

export default ListExtender;
